import { render } from "./CartView.vue?vue&type=template&id=f8c630a2&scoped=true"
import script from "./CartView.vue?vue&type=script&lang=js"
export * from "./CartView.vue?vue&type=script&lang=js"

import "./CartView.vue?vue&type=style&index=0&id=f8c630a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8c630a2"]])

export default __exports__